<template>
  <!-- 龙源果实微授权 -->
  <div class="microAuthorization_component">
      <h4>可帮助您</h4>
      <p class="titleSub">拥有海量深度内容，增加用户使用时长，提升用户活跃度，节省运营成本，安全绿色正版授权</p>
      <div class="microAuthorizationWarp">
        <ul>
            <li>
                <div class="contentBoxWarp" v-for="(item,index) in carList.left" :key="index"><p v-html="item.title"></p><span></span></div>
            </li>
            <li>
                <div class="contentBoxWarp" v-for="(item,index) in carList.right" :key="index"><span></span><p v-html="item.title"></p></div>
            </li>
        </ul>
        <div class="content_mainImg"><img v-lazy="require('@/assets/home/zuhedatu.png')"></div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'microAuthorization_component',
  data () {
    return {
        carList:{
            left:[
                {title:"需要生产大量内容，涉足多个领域，无法持<br/>续高效产出优质内容"},
                {title:"内容源多来自于抓取采集，内容版权风险极高，可能面临封号、下架"},
                {title:"用户需求的内容具有权威性、知识性、内容<br/>生成成本高、无法满足用户垂直细分领域的<br/>深度阅读需求"}
            ],
            right:[
                {title:"海量多维度高质内容不断更新<br/>节省编辑运营成本、优质内容量提升N倍<br/>内容权威性有保障"},
                {title:"安全、绿色、正版、解决100%版权风险所有文章均来自中国顶级杂志期刊"},
                {title:"提升用户的使用时长、提升用户粘性、活<br/>跃度、共享期刊杂志品牌影响力"}
            ]
        }
    }
  },
  methods:{

  },
  mounted(){

  }
}
</script>

<style scoped lang="less">
.microAuthorization_component{
    padding:0 0 46px 0;
    color:rgba(51,51,51,1);
    h4{
        height:40px;
        font-size:24px;
        font-weight:600;
        line-height:40px;
        text-align: center;
        padding:20px 0;
        color:rgba(51, 51, 51, 1);
    }
    .titleSub{
        height:24px;
        font-size:24px;
        font-weight:400;
        text-align: center;
        padding-bottom:42px;
        color:rgba(21, 47, 106, 1);
        line-height:24px;
    }
    .microAuthorizationWarp{
        position: relative;
        ul{
            color:#ffffff;
            display: flex;
            justify-content: space-between;
            li{
                padding: 44px 0;
                height: 360px;
                width: 50%;
                font-size: 16px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .contentBoxWarp{
                    display: flex;
                    align-items: center;
                    span{
                        width:20px;
                        height:20px;
                        border-radius: 50%;
                        display: block;
                    }
                }
            }
            li:nth-child(1){
                background: rgba(64, 125, 248, 1);
                text-align: right;
                .contentBoxWarp{
                    height: 30%;
                    justify-content: flex-end;
                    span{
                        margin-left: 34px;
                        background: rgba(21, 47, 106, 1);
                    }
                }
                .contentBoxWarp:nth-child(1){
                    padding-right: 176px;
                }
                .contentBoxWarp:nth-child(2){
                    padding:100px 280px 80px 0px;
                    p{
                        width: 280px;
                    }
                }
                .contentBoxWarp:nth-child(3){
                    padding-right: 176px;
                }
            }
            li:nth-child(2){
                background: rgba(21, 47, 106, 1);
                justify-content: flex-start;
                .contentBoxWarp{
                    span{
                        margin-right: 34px;
                        background: rgba(64, 125, 248, 1);
                    }
                }
                 .contentBoxWarp:nth-child(1){
                    padding-left: 176px;
                }
                .contentBoxWarp:nth-child(2){
                    padding:100px 0 80px 276px;
                    p{
                        width: 280px;
                    }
                }
                .contentBoxWarp:nth-child(3){
                    padding-left: 176px;
                }
            }
        }
        .content_mainImg{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            // height: 310px;
            width: 554px;
            width:480px;
            img{
                width: 100%;
                // height: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/home/homeComponents/microAuthorization.vue